import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider } from 'react-redux';
import store from './store';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { OllieThemeProvider } from './styles/OllieThemeProvider';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <OllieThemeProvider>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <App />
        </Provider>
      </QueryClientProvider>
    </OllieThemeProvider>
);

reportWebVitals();
